Vue.component('page-psf-airport', {

    mixins: [],

    computed: {},

    watch: {

    },

    data: function () {
        return {
            airport: apr.content.content
        }
    },

    mounted() {

    },

    methods: {

    }
});
